export enum WALLET_TYPE {
    UNSET = 'unset',
    METAMASK = 'metamask',
    WALLET_CONNECT = 'walletConnect',
}
